import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {AbstractVisbosComponent} from "../../../../core/visbos-core/components/abstract-visbos.component";
import {SessionActions} from "../../../../shared/actions";
import {SubAdminUnitNeedsComponent} from "../../sub-admin-unit-needs/sub-admin-unit-needs.component";
import {MessageType} from "../../../../shared/redux-store/session/session.types";
import {FileService} from "../../../../core/visbos-core/http/file.service";
import {Location} from "@angular/common";

@Component({
  selector: 'vb-fill-up-depot-view',
  templateUrl: './fill-up-depot-view.component.html',
  styleUrls: ['./fill-up-depot-view.component.css']
})
export class FillUpDepotViewComponent extends AbstractVisbosComponent implements OnInit {

  @ViewChild(SubAdminUnitNeedsComponent)
  component: SubAdminUnitNeedsComponent;

  constructor(sessionActions: SessionActions, cd: ChangeDetectorRef,
              private fileService: FileService,
              private loc: Location) {
    super(sessionActions, cd);

    this.actions = [
      {
        label: "Packliste generieren",
        action: () => this.onGenerateDispatchListPdfClick.apply(this),
        icon: 'fa-file-pdf',
        helpText: 'Packliste als PDF generieren',
        disabled: () => !this.component.canGenerateDispatchListPdf.apply(this.component)
      },
      {
        label: "Bestände verschieben",
        action: () => this.onDispatchItemsClick.apply(this),
        icon: 'fa-cart-arrow-down',
        helpText: 'Bestände im Ziellager auffüllen',
        disabled: () => !this.component.canSend.apply(this.component)
      }
    ]

  }

  onGenerateDispatchListPdfClick() {
    this.component.onGenerateDispatchListPdfClick()
      .then(res => {
        let data = this.fileService.base64toBlob(res.data.dispatchListPdf, 'application/pdf', 512);
        this.fileService.saveAs(data, "packliste.pdf");
      })
      .catch(err => this.sessionActions.throwError(err));
  }

  onDispatchItemsClick() {

    this.component.onDispatchItemsClick()
      .then(res => {
        this.sessionActions.pushMessage("Lager erfolgreich aufgefüllt!", MessageType.SUCCESS, "Lager auffüllen");

        const pdfWithdrawal = res.data.fillUpDepot.voucher_withdrawal;
        const pdfWarehousing = res.data.fillUpDepot.voucher_warehousing;

        if (pdfWithdrawal) {
          let data = this.fileService.base64toBlob(pdfWithdrawal, 'application/pdf', 512);
          this.fileService.saveAs(data, 'warenausgangsbeleg.pdf');
        }

        if (pdfWarehousing) {
          let data = this.fileService.base64toBlob(pdfWarehousing, 'application/pdf', 512);
          this.fileService.saveAs(data, 'wareneingangsbeleg.pdf');
        }

        this.loc.back();

      })
      .catch(err => {
        this.sessionActions.throwError(err, "Fehler beim Auffüllen, Bestände wurden nicht geändert!", "Lager auffüllen");
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/store-management/procurement/views/fill-up-depot-view/fill-up-depot-view.component.ts